export const packageConst = {
  appName: '@krishanmadan/core',
  appVersion: '1.0.1',
};
